










































































































































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import { gps } from "@/config/host.config";
import { IGpsServerConfig } from "@/@types/filoxenia-config/gps-config";

import StandartModal from "@/components/app/standart-modal.vue";
import StandartSelect from "@/components/app/selects/standart-select.vue";
import StandartSwitch from "@/components/app/switchs/standart-switch.vue";

type GpsSectionKey = Exclude<keyof IGpsServerConfig, "demo">;
type GpsSectionId = "main" | GpsSectionKey;

interface IGpsSectionItem {
  id: GpsSectionId;
  icon: string;
  title: string;
}

@Component({
  name: "gps-config-settings",
  components: {
    StandartModal,
    "s-switch": StandartSwitch,
    "s-select": StandartSelect,
  },
})
class GpsConfigSettings extends Vue {
  form: IGpsServerConfig | null = null;
  loading = false;
  activeSection: GpsSectionId = "main";
  validationFields: Array<string> = [
    "speedDiff",
    "posDiff",
    "normalSpeed",
    "minSpeed",
    "maxDubnaAge",
    "maxAisAge",
  ];

  sectionIcons: Record<GpsSectionId, string> = {
    main: "compass",
    ais: "broadcast",
    validation: "shield-check",
    track: "signpost-split",
    geocoder: "geo-alt",
    flightradar: "binoculars",
    osm: "map",
    tileCache: "layers",
    redis: "cpu",
  };

  get demo(): boolean {
    return this.form?.demo === true;
  }

  get sectionList(): Array<IGpsSectionItem> {
    if (!this.form) return [];
    const sections: Array<GpsSectionId> = [
      "main",
      "ais",
      "validation",
      "track",
      "geocoder",
      "flightradar",
      "osm",
      "tileCache",
      "redis",
    ];
    return sections
      .filter((s) => (s === "main" ? true : !!this.form?.[s as GpsSectionKey]))
      .map((s) => ({
        id: s,
        icon: this.sectionIcons[s],
        title: String(this.$t(`configuration.gps.${s}.title`)),
      }));
  }

  get osmSourceOptions(): Array<{ value: string; text: string }> {
    const sources =
      this.form?.osm?.enum && this.form.osm.enum.length
        ? this.form.osm.enum
        : ["tileserver", "osm"];
    return sources.map((s) => ({
      value: s,
      text: String(this.$t(`configuration.gps.osm.sources.${s}`)),
    }));
  }

  updateDemo(value: boolean): void {
    if (!this.form) return;
    this.form.demo = value;
  }

  async saveDemo(): Promise<void> {
    if (!this.form) return;
    try {
      const res = await this.$axios.put(gps.config, { demo: this.form.demo });
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  async saveSection(section: GpsSectionKey): Promise<void> {
    if (!this.form) return;
    try {
      const payload = { [section]: this.form[section] };
      const res = await this.$axios.put(gps.config, payload);
      if (res.status === 200) {
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("error.200")),
        });
        this.createConfiguration();
      } else
        this.$notify({
          group: "global",
          text: String(this.$i18n.t("alerts.emptyUpdate")),
          type: "warn",
        });
    } catch (error) {
      console.log(error);
    }
  }

  async createConfiguration(): Promise<void> {
    this.loading = true;
    try {
      const res = await this.$axios.get(gps.config);
      if (res.status === 200) {
        this.form = res.data;
        if (!this.sectionList.some((s) => s.id === this.activeSection))
          this.activeSection = "main";
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }
}
export default GpsConfigSettings;
